import AuthenticationContext from 'adal-angular';

export default class AuthManager {

    private static instance: AuthManager;
    public authenticationContext: AuthenticationContext;

    private constructor() {
        const config: AuthenticationContext.Options = {
            tenant: process.env.VUE_APP_TENANT_ID,
            clientId: String(process.env.VUE_APP_CLIENT_ID),
            redirectUri: process.env.VUE_APP_REDIRECT_URI,
            cacheLocation: 'sessionStorage',
        };

        this.authenticationContext = new AuthenticationContext(config);
    }

    public static get Instance() {
        if (this.instance === null || this.instance === undefined) {
            this.instance = new AuthManager();
        }
        return this.instance;
    }

    public initialize() {
        return new Promise((resolve, reject) => {
            if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
              // redirect to the location specified in the url params.
              this.authenticationContext.handleWindowCallback();
            } else {
              // try pull the user out of local storage
              const user = this.authenticationContext.getCachedUser();
              if (user) {
                resolve(0);
              } else {
                // no user at all - go sign in.
                this.signIn();
              }
            }
          });
    }
    public acquireTokenRedirect() {
        this.authenticationContext.acquireTokenRedirect(String(process.env.VUE_APP_SMART_API_ID));
    }
    /**
     * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
     */
    public isAuthenticated(): boolean {
      // getCachedToken will only return a valid, non-expired token.
      if (this.authenticationContext.getCachedToken(String(process.env.VUE_APP_CLIENT_ID))) { return true; }
      return false;
    }
    /**
     * @return An ADAL user profile object.
     */
    public getUserProfile() {
      return this.authenticationContext.getCachedUser().profile;
    }
    public signIn() {
      this.authenticationContext.login();
    }
    public signOut() {
      this.authenticationContext.logOut();
    }
}
